<template>
  <div class="manager-menu">
    <MenuBaseComponent :menu-properties="menuProperties" />
  </div>
</template>

<script>
import MenuBaseComponent from "@/components/navigation/menu/utils/MenuBaseComponent";
import {createAnnouncementMe, changeTable, userDetailsAdmin, announcementsSxhmatismos, teams} from "@/config/menuopts"
export default {
  name: "ManagerMenu",
  components: {MenuBaseComponent},
  data() {
    return {
      menuProperties: {
        createAnnouncementMe,
        changeTable,
        userDetailsAdmin,
        announcementsSxhmatismos,
        teams,
      }
    }
  }
}
</script>

<style scoped>

</style>